<template>
  <div class="mobile-button-container">
    <v-flex class="mb-16 mobile-button hide">
      <main-button
        depressed
        :text="adminText('organizationAll.create_email_cf6523ed', 'Create email')"
        @click="goTo(routes.sportOrganization.sportOrganizationMembershipsEmailsNew, { organizationSlug: organizationSlug })"
      />
    </v-flex>
    <v-layout column>
      <div class="page-header">
        <v-flex class="title-screen" xs12>
          <span>{{ adminText('organizationAll.e_mails_to_members_b285f983', 'E-mails to members') }}</span>
        </v-flex>
        <v-flex class="mb-16 desktop-button">
          <main-button
            depressed
            @click="goTo(routes.sportOrganization.sportOrganizationMembershipsEmailsNew, { organizationSlug: organizationSlug })"
          >
            <div class="plus-sign">+</div>
            {{ adminText('organizationAll.create_email_cf6523ed', 'Create email') }}
          </main-button>
        </v-flex>
      </div>
      <v-data-table
        v-model="tableValue"
        :headers="organizationHeaders(headers)"
        :items="items"
        :rows-per-page-items="rowsPerPageItems"
        :rows-per-page-text="isDesktop ? adminText('organizationAll.rows_per_page_79df325c', 'Rows per page:') : ''"
        item-key="id"
        disable-initial-sort
        style="border: 1px solid #f5f5f5f !important"
        class="table-container"
      >
        <template slot="items" slot-scope="props">
          <tr
            style="
              position: relative;
              z-index: 4;
              cursor: pointer;
              border: 1px solid #f5f5f5 !important;
            "
            @click="openEmailDetails(props.item.id)"
          >
            <td>
              <div class="custom-type-style">
                <span>{{ organizationText(props.item.type) }}</span>
              </div>
            </td>
            <td>
              <span>{{ organizationDate(props.item.updatedAt, 'LL H:mm') }}</span>
            </td>
            <td>{{ props.item.subject }}</td>
            <td>{{ organizationRecipientLabel(props.item.emailRecipient.recipientType) }}</td>
            <td>
              <v-icon
                :key="props.item.id"
                small
                @click.prevent="e => startDelete(props.item, e)"
              >
                delete
              </v-icon>
            </td>
          </tr>
        </template>
        <template slot="no-data"> {{ adminText('organizationAll.create_your_email_57e3cb3a', 'Create your email') }} </template>
      </v-data-table>
    </v-layout>
    <delete-dialog
      :content="`${adminText('organizationAll.are_you_sure_you_want_to_delete_selected_emai_23aa06bb', 'Are you sure you want to delete selected email? This operation cannot be undone.')}`"
      :on-delete="deleteEmail"
      :show.sync="showDeleteDialog"
      :title="adminText('organizationAll.delete_email_12b2a4ea', 'Delete email')"
    />
  </div>
</template>

<script>
import OrganizationLocalization from '@/components/organizations/organization-all-display'

import {
  DELETE_EMAIL,
  GET_EMAILS_BY_ORGANIZATION,
} from '@/graphql/email.graphql'
import DeleteDialog from '@/components/shared/dialogs/delete-dialog.vue'

export default {
  mixins: [OrganizationLocalization],
  name: 'sport-memberships-emails',
  components: {
    DeleteDialog,
  },
  props: {
    organizationSlug: String,
  },
  data() {
    return {
      attendeeFields: [],
      eventAttendeeFields: {},
      showDeleteDialog: false,
      tableValue: [],
      deleteId: undefined,
      isDesktop: false,
      headers: [
        {
          text: 'Type',
          align: 'left',
          sortable: true,
          value: 'type',
        },
        {
          text: 'Sent',
          align: 'left',
          sortable: true,
          value: 'sent',
        },
        {
          text: 'Subject',
          align: 'left',
          sortable: true,
          value: 'subject',
        },
        {
          text: 'Recipients',
          align: 'left',
          sortable: true,
          value: 'recipients',
        },
        {
          text: '',
          align: 'left',
          sortable: false,
          value: null,
        },
      ],
      items: [],
      rowsPerPageItems: [5, 10, 25, 100],
    }
  },
  apollo: {
    getEmailsByOrganizationSlug: {
      query: GET_EMAILS_BY_ORGANIZATION,
      variables() {
        return {
          organizationSlug: this.organizationSlug,
          membershipEmail: true,
        }
      },
      result({ data, loading }) {
        if (!loading) {
          const { getEmailsByOrganizationSlug } = data
          this.items = getEmailsByOrganizationSlug
            .map(email => {
              return {
                ...email,
              }
            })
            .sort((a, b) => {
              return a.id - b.id
            })
        }
      },
    },
  },
  created() {
    window.addEventListener('resize', this.resizeHandler)
    if (window.innerWidth > 800) {
      this.isDesktop = true
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler)
  },
  methods: {
    openEmailDetails(id) {
      console.log('EMAIL DETAILS')
      // this.goTo(this.routes.organizer.emailDetails, { eventId: this.eventId, emailId: id })
    },
    resizeHandler() {
      if (window.innerWidth > 800) {
        this.isDesktop = true
      } else {
        this.isDesktop = false
      }
    },
    startDelete(email, ev) {
      ev.stopPropagation()
      this.showDeleteDialog = true
      this.deleteId = email.id
    },
    async deleteEmail() {
      await this.$apollo.mutate({
        mutation: DELETE_EMAIL,
        variables: { emailId: this.deleteId },
        refetchQueries: ['GetEmailsByOrganizationSlug'],
      })
      this.showDeleteDialog = false
      this.deleteId = undefined
    },
  },
}
</script>

<style scoped>
.screen-description {
  max-width: 680px;
  margin-bottom: 28px;
}
.automated-type-style {
  width: 81px;
  height: 24px;
  border-radius: 4px;
  background-color: rgba(2, 119, 189, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #0277bd;
}
.custom-type-style {
  width: 61px;
  height: 24px;
  border-radius: 4px;
  background-color: rgba(51, 51, 51, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #333333;
}
.sent-style {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #333333;
}
>>> .v-input--selection-controls {
  margin-bottom: 0px !important;
  padding-top: 0px !important;
}
>>> .v-input__slot {
  margin-bottom: 0px !important;
}
>>> .v-messages {
  min-height: 0px !important;
}
.page-header {
  display: flex;
  align-items: flex-end;
}
.plus-sign {
  font-size: 2.25rem;
  font-weight: 100;
  margin-right: 0.625rem;
}
.title-screen {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}
@media screen and (max-width: 800px) {
  .title-screen {
    display: none;
  }
}
</style>
